<template>
  <el-dialog
      :visible.sync="visible"
      title="设置开票户头"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-form-item label="开票户头：" prop="receiptAccount">
        <CommonDrop ref="drop" v-model="dataForm.receiptAccount" val-name="accountName" label-name="accountName"
                    url="/settings/account/list" :autoDefault="false" size="mini"></CommonDrop>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="doSave()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import CommonDrop from '@/components/CommonDrop'

export default {
  name: 'set-receipt-account',
  components: { CommonDrop },
  data () {
    return {
      visible: false,
      dataForm: {
        ids: [],
        receiptAccount: ''
      },
      dataRule: {
        receiptAccount: [{ required: true, message: '请选择', trigger: 'change' }]
      },
    }
  },
  methods: {
    init (ids) {
      if(this.$c.isArrayEmpty(ids)){
        return this.$message.error('请选择要操作的数据')
      }
      this.dataForm.ids=ids
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
      })
    },
    doSave () {
      this.$refs.dataForm.validate(async (valid) => {
        if (!valid) {
          return false
        }
        let postForm = {
          ...this.dataForm
        }
        const res = await this.$api2.post('/trade/order/set/receipt_account', postForm)
        this.$message.success('保存成功')
        this.visible = false
        this.$emit('changed')
      })
    },
  }
}
</script>

<style scoped>

</style>
